import React from 'react';
import { Trans } from '@lingui/macro';

function Home() {
  return (
    <section className="home-section" id="home">
      <div className="home-bg">
        <div className="home-gradient"></div>
        <div className="home-particles">
          {[...Array(20)].map((_, i) => (
            <div key={i} className="particle" style={{ '--delay': `${Math.random() * 10}s`, '--x': `${Math.random() * 100}%`, '--duration': `${10 + Math.random() * 10}s` }}></div>
          ))}
        </div>
      </div>
      <div className="home-content">
<img src="images/logo-text-light-hr.png" className="home-logo mb-4" alt="" />
              <div className="home-badge">
                {/* <Trans>August 22, 2026</Trans> */}
                {/* <span className="badge-divider">|</span> */}
                Manseau, QC, Canada
              </div>
        <p className="home-subtitle mb-4">
          {/* <Trans>Tickets are on sale NOW!</Trans> */}
          <Trans>The 2026 photos are available NOW!</Trans>
        </p>
        {/* <a href="https://shop.amarefestival.com" className="home-btn"> */}
          {/* <Trans>BUY TICKETS</Trans> */}
          {/* <i className="mdi mdi-arrow-right ms-2"></i> */}
        {/* </a> */}
      </div>
      <div className="home-scroll-indicator">
        <div className="scroll-mouse">
          <div className="scroll-wheel"></div>
        </div>
        <span><Trans>Scroll Down</Trans></span>
      </div>
    </section>
  );
}

export default Home;